"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSubjectId;

var _constants = _interopRequireDefault(require("./constants"));

function createSubjectId(productId, ruleCode) {
  return ruleCode ? "".concat(ruleCode).concat(_constants.default.INDIRECT_SUBJECT_SEPARATOR).concat(productId) : productId;
}